import React from 'react'

import Input from '../../../components/Input/Input'
import TextEditor from '../../../components/TextEditor/TextEditor'

const FormInputsEn = ({ errors, status, touched, isSubmitting, values, setFieldValue }) => {
    const { titleEn, textEn } = values

    return (
        <>
            <Input
                name="titleEn"
                id="titleEn"
                type="text"
                errors={errors}
                touched={touched}
                label="Naslov En"
                setFieldValue={setFieldValue}
                value={titleEn}
            />
            <TextEditor
                data={textEn}
                setFieldValue={setFieldValue}
                label="Tekst En"
                name="textEn"
            />
        </>
    )
}

export default FormInputsEn
